<template>
  <div class="inner-container pipeline-page" :class="{ 'min-container': !getTabs, 'pipeline-embedded': isEmbedded }">
    <div v-if="!isEmbedded" class="page-header d-flex flex-wrap align-items-center justify-content-between">
      <h1>{{  "Pipeline" }}</h1>
      <b-spinner v-if="getPipelineLoading" small label="Chargement..." />
    </div>

    <div class="content pipeline-content" :class="{ 'pipeline-content-embedded': isEmbedded }">
      <!-- Spinner dans le contenu -->
      <div v-if="getPipelineLoading" class="pipeline-content-loading">
        <div class="loading-content">
          <b-spinner large />
       
        </div>
      </div>

      <!-- Contenu du pipeline -->
      <div v-else>
        <div v-if="!isEmbedded" class="pipeline-card-header">
      <!--  <multiselect
          v-if="isSuperAdmin"
          v-model="filterEntreprise"
          :options="entrepriseFilterOptions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          label="lib"
          track-by="id"
          :placeholder="$t('Filter_entreprise') || 'Filtrer par entreprise'"
          class="pipeline-filter-multiselect"
        />
        <multiselect
          v-model="filterOperation"
          :options="operationOptionsFiltered"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          label="text"
          track-by="value"
          :placeholder="$t('Filter_operation') || 'Filtrer par opération'"
          class="pipeline-filter-multiselect"
        />
        <multiselect
          v-model="filterDossier"
          :options="dossierFilterOptions"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          label="label"
          track-by="id"
          :placeholder="$t('Filter_dossier') || 'Filtrer par dossier'"
          class="pipeline-filter-multiselect"
        />
        <multiselect
          v-model="filterClient"
          :options="clientFilterOptions"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :custom-label="clientLabel"
          track-by="id"
          :placeholder="$t('Filter_client') || 'Filtrer par client'"
          class="pipeline-filter-multiselect"
        />-->
      </div>
      <div class="pipeline-board" ref="boardRef">
      
      <div
        v-for="(col, colIndex) in filteredColumns"
        :key="col.id"
        class="pipeline-column"
        :class="{ 'column-dragover': dragOverColumnId === col.id }"
        :data-column-id="col.id"
        @dragover.prevent="onColumnDragOver($event, col)"
        @dragleave="onColumnDragLeave"
        @drop="onColumnDrop($event, col)"
      >
        <div
          class="pipeline-column-header"
          :style="{ backgroundColor: col.color || '#6c757d' }"
          draggable="true"
          @dragstart="onColumnDragStart($event, col, colIndex)"
          @dragend="onColumnDragEnd"
        >
          <font-awesome-icon :icon="getIconName(col.icon)" class="column-icon" />
          <span class="column-name">{{ col.name }}</span>
          <span class="column-count">{{ getColumnCards(col).length }}</span>
          <b-button
            size="sm"
            variant="link"
            class="column-edit-btn"
            @click.stop="openEditSectionModal(col)"
          >
            <font-awesome-icon icon="edit" />
          </b-button>
          <b-button
            size="sm"
            variant="link"
            class="column-remove-btn"
            @click.stop="removeSection(col)"
          >
            <font-awesome-icon icon="times" />
          </b-button>
        </div>

        <div
          class="pipeline-column-content"
          @dragover.prevent="onColumnDragOver($event, col)"
          @drop="onColumnDrop($event, col)"
        >
          <div
            v-for="ss in getSousSections(col)"
            :key="ss.id"
            class="pipeline-sous-section"
            :class="{ 'sous-section-dragover': dragOverSousSectionId === ss.id }"
            @dragover.prevent="onSousSectionDragOver($event, col, ss)"
            @dragleave="onSousSectionDragLeave"
            @drop="onSousSectionDrop($event, col, ss)"
          >
            <div class="sous-section-header">
              <span class="sous-section-name">{{ ss.name }}</span>
              <b-button
                size="sm"
                variant="link"
                class="sous-section-remove"
                @click.stop="removeSousSection(col, ss)"
              >
                <font-awesome-icon icon="times" />
              </b-button>
            </div>
            <div
              v-for="card in getSousSectionCards(ss)"
              :key="card.id"
              class="pipeline-card"
              draggable="true"
              @dragstart="onCardDragStart($event, card, col, ss)"
              @dragend="onCardDragEnd"
            >
              <div class="card-name">{{ card.dossier_name || card.name }}</div>
              <div v-if="card.dossier_reference" class="card-reference">{{ card.dossier_reference }}</div>
              <div v-if="card.client_name" class="card-client">{{ card.client_name }}</div>
              <b-button
                size="sm"
                variant="link"
                class="card-remove-btn"
                @click.stop="removeCard(card, col, ss)"
              >
                <font-awesome-icon icon="times" />
              </b-button>
            </div>

            <div v-if="getSousSectionCards(ss).length === 0" class="column-empty">
              <span>{{ $t("NO_TASK") || "Aucune tâche" }}</span>
            </div>

            <b-button
              size="sm"
              variant="outline-secondary"
              class="add-task-btn"
              @click="openAddTaskModal(col, ss)"
            >
              <font-awesome-icon icon="plus" /> {{ "Ajouter une tâche" }}
            </b-button>
          </div>

          <b-button
            size="sm"
            variant="outline-primary"
            class="add-sous-section-btn"
            @click="openAddSousSectionModal(col)"
          >
            <font-awesome-icon icon="plus" /> Ajouter une sous-section
          </b-button>
        </div>
      </div>

      <div class="pipeline-add-section-column" @click="openAddSectionModal">
        <font-awesome-icon icon="plus" class="add-section-icon" />
        <span>Ajouter une section</span>
      </div>
    </div>
    </div>

    <!-- Modal: Ajouter / Modifier une section -->
    <b-modal
      id="addSectionModal"
      ref="addSectionModal"
      :title="editingSectionColumn ? ('Modifier la section') : ('Ajouter une section')"
      @hidden="resetSectionModal"
    >
      <b-form @submit.prevent="editingSectionColumn ? updateSection() : addSection()">
        <b-form-group :label="$t('NAME') || 'Nom'">
          <b-form-input v-model="newSection.name" required placeholder="Ex: LEAD, EN COURS..." />
        </b-form-group>
        <b-form-group :label="'Couleur'">
          <div class="d-flex align-items-center gap-2">
            <input
              v-model="newSection.color"
              type="color"
              class="color-picker"
            />
            <b-form-input v-model="newSection.color" size="sm" />
          </div>
        </b-form-group>
        <b-form-group :label="'Icône'">
          <b-form-select
            v-model="newSection.icon"
            :options="iconOptions"
            value-field="value"
            text-field="text"
          />
        </b-form-group>
      <!--  <b-form-group :label="$t('Type_opération') || 'Type d\'opération'">
          <b-form-select
            v-model="newSection.operation"
            :options="operationOptions"
            value-field="value"
            text-field="text"
          />
        </b-form-group>-->
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.addSectionModal.hide()">
          <span style="color: white;">{{ $t("CANCEL") || "Annuler" }}</span>
        </b-button>
        <b-button variant="primary" class="btn-primary text-white" @click="editingSectionColumn ? updateSection() : addSection()">
          {{ $t("SAVE") || "Enregistrer" }}
        </b-button>
      </template>
    </b-modal>

    <!-- Modal: Ajouter une sous-section -->
    <b-modal
      id="addSousSectionModal"
      ref="addSousSectionModal"
      :title=" 'Ajouter une sous-section'"
      @hidden="resetSousSectionModal"
    >
      <b-form @submit.prevent="addSousSection">
        <b-form-group v-if="addSousSectionFromHeader" :label=" 'Section'">
          <b-form-select
            v-model="addSousSectionTargetColumnId"
            :options="sectionSelectOptions"
            value-field="id"
            text-field="name"
          />
          <small v-if="sectionSelectOptions.length === 0" class="text-muted">{{  "Aucune section. Créez d'abord une section." }}</small>
        </b-form-group>
        <b-form-group :label="$t('NAME') || 'Nom'">
          <b-form-input
            v-model="newSousSection.name"
            required
            :placeholder=" 'Nom de la sous-section'"
          />
        </b-form-group>
      
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.addSousSectionModal.hide()">
          {{ $t("CANCEL") || "Annuler" }}
        </b-button>
        <b-button variant="primary" class="btn-primary text-white" @click="addSousSection">
          {{ $t("SAVE") || "Enregistrer" }}
        </b-button>
      </template>
    </b-modal>

    <!-- Modal: Ajouter une tâche (card) -->
    <b-modal
      id="addTaskModal"
      ref="addTaskModal"
      :title=" 'Ajouter une tâche'"
      @hidden="resetTaskModal"
    >
      <b-form @submit.prevent="addTask">
        <b-form-group :label=" 'Dossier'" required>
          <multiselect
            v-model="newTask.dossier"
            :options="dossierTaskOptions"
            :multiple="false"
            label="label"
            track-by="id"
            :placeholder=" 'Sélectionner un dossier'"
            class="form-input custom-placeholder custom-input"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.addTaskModal.hide()">
          {{ $t("CANCEL") || "Annuler" }}
        </b-button>
        <b-button variant="primary" class="btn-primary text-white" :disabled="!newTask.dossier" @click="addTask">
          {{ $t("ADD") || "Ajouter" }}
        </b-button>
      </template>
    </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const STORAGE_KEY = "batigo_pipeline";

const ICON_OPTIONS = [
  { value: "lightbulb", text: "Ampoule" },
  { value: "bolt", text: "Éclair" },
  { value: "envelope", text: "Enveloppe" },
  { value: "calendar-alt", text: "Calendrier" },
  { value: "calendar-check", text: "Calendrier validé" },
  { value: "pen", text: "Stylo" },
  { value: "pen-fancy", text: "Signature" },
  { value: "times", text: "Croix" },
  { value: "wrench", text: "Clé" },
  { value: "check", text: "Valider" },
  { value: "user", text: "Utilisateur" },
  { value: "building", text: "Bâtiment" },
];

const OPERATION_OPTIONS = [
  { value: null, text: "—" },
  { value: "BAR-EN-101", text: "BAR-EN-101" },
  { value: "BAR-TH-161", text: "BAR-TH-161" },
  { value: "BAT-TH-142", text: "BAT-TH-142" },
  { value: "renovation d'ampleur", text: "renovation d'ampleur" },
];

export default {
  name: "Pipeline",
  props: {
    processusId: { type: [Number, String], default: null },
  },
  data() {
    return {
      columns: [],
      filterEntreprise: [],
      filterOperation: [],
      filterDossier: null,
      filterClient: null,
      operationOptions: OPERATION_OPTIONS,
      iconOptions: ICON_OPTIONS,
      newSection: { name: "", color: "#6c757d", icon: "check", operation: null },
      newSousSection: { name: "" },
      newTask: { dossier: null },
      addTaskTargetColumn: null,
      addTaskTargetSousSection: null,
      addSousSectionTargetColumn: null,
      addSousSectionFromHeader: false,
      addSousSectionTargetColumnId: null,
      editingSectionColumn: null,
      dragOverColumnId: null,
      dragOverSousSectionId: null,
      nextSousSectionId: 1,
      draggingCard: null,
      draggingCardFromColumn: null,
      draggingCardFromSousSection: null,
      draggingColumn: null,
      draggingColumnIndex: null,
      nextCardId: 1,
      nextColumnId: 10,
      loadPipelineDebounce: null,
    };
  },
  computed: {
    ...mapGetters(["getTabs", "getAlldossiers", "getDossiersByOperation", "getAllclients", "getAllentreprises", "getPipelineLoading", "getOnlineUser"]),
    computedProcessusId() {
      const fromProp = this.processusId;
      if (fromProp != null && fromProp !== "") {
        const num = parseInt(fromProp, 10);
        return isNaN(num) ? null : num;
      }
      const id = this.$route.params.id;
      if (id == null || id === "") return null;
      const num = parseInt(id, 10);
      return isNaN(num) ? null : num;
    },
    isEmbedded() {
      return this.processusId != null && this.processusId !== "";
    },
    isSuperAdmin() {
      return this.getOnlineUser?.role === "user.super-admin";
    },
    entrepriseFilterOptions() {
      return this.getAllentreprises || [];
    },
    filteredColumns() {
      return this.columns;
    },
    operationOptionsFiltered() {
      return OPERATION_OPTIONS.filter((o) => o.value != null);
    },
    sectionSelectOptions() {
      return this.columns.map((c) => ({ id: c.id, name: c.name }));
    },
    dossierFilterOptions() {
      const list = this.getAlldossiers || [];
      const all = { id: null, label: this.$t("ALL") || "Tous" };
      const opts = list.map((d) => ({
        id: d.id,
        label: (d.name || d.numero_dossier || "Dossier #" + d.id) + (d.client ? ` (${d.client.nom || ""} ${d.client.prenom || ""})`.trim() : ""),
      }));
      return [all, ...opts];
    },
    clientFilterOptions() {
      const list = this.getAllclients || [];
      const all = { id: null, nom: "", prenom: "", company: "" };
      return [{ ...all, id: null, _label: this.$t("ALL") || "Tous" }, ...list];
    },
    dossierTaskOptions() {
      const list = this.addTaskTargetColumn
        ? (this.getDossiersByOperation || [])
        : (this.getAlldossiers || []);
      return list.map((d) => {
        const name = d.name || d.numero_dossier || "Dossier #" + d.id;
        return {
          id: d.id,
          name,
          numero_dossier: d.numero_dossier,
          label: name + (d.client ? ` - ${this.clientLabel(d.client)}` : ""),
          client_id: d.client_id || (d.client && d.client.id),
          client: d.client,
        };
      });
    },
  },
  created() {
    this.loadPipeline();
    if (!this.isEmbedded) {
      this.loadDossiersAndClients();
      if (this.isSuperAdmin) {
        this.all_entreprises({ page: 1, per_page: 10 });
      }
    }
  },
  beforeDestroy() {
    if (this.loadPipelineDebounce) {
      clearTimeout(this.loadPipelineDebounce);
    }
  },
  watch: {
    columns: {
      handler() {
        clearTimeout(this._savePipelineTimer);
        this._savePipelineTimer = setTimeout(() => this.saveToStorage(), 800);
      },
      deep: true,
    },
    filterOperation: {
      handler() {
        this.debouncedLoadPipeline();
      },
      deep: true,
    },
    filterClient: {
      handler() {
        this.debouncedLoadPipeline();
      },
      deep: true,
    },
    filterDossier: {
      handler() {
        this.debouncedLoadPipeline();
      },
      deep: true,
    },
    filterEntreprise: {
      handler() {
        this.debouncedLoadPipeline();
        if (!this.isEmbedded) {
          this.loadDossiersAndClients();
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["alldossier", "all_clients", "all_entreprises", "dossiersByOperation", "getPipeline", "savePipeline", "saveSousPipeline", "saveTask", "updateTask", "deleteTask", "updatePipeline", "deletePipeline", "deleteSousPipeline"]),
    clientLabel(client) {
      if (!client) return "";
      if (client._label) return client._label;
      if (client.type === "type.professionnel") return client.company || client.raison_sociale || client.nom || "Client";
      return [client.nom, client.prenom].filter(Boolean).join(" ") || "Client";
    },
    async loadDossiersAndClients() {
      try {
        const isSuperAdmin = this.getOnlineUser?.role === "user.super-admin";
        const selectedEnt = Array.isArray(this.filterEntreprise) ? this.filterEntreprise : [];
        const entrepriseIds = selectedEnt.map((e) => e && e.id).filter((id) => id != null);
        const clientPayload = { page: 1, per_page: 1000 };
        if (isSuperAdmin && entrepriseIds.length > 0) {
          clientPayload.entreprise_id = entrepriseIds[0];
        }
        await Promise.all([
          this.alldossier({ page: 1, per_page: 500 }),
          this.all_clients(clientPayload),
        ]);
      } catch (e) {
        console.warn("Pipeline: load dossiers/clients failed", e);
      }
    },
    getIconName(icon) {
      if (!icon) return "check";
      return icon;
    },
    debouncedLoadPipeline() {
      if (this.loadPipelineDebounce) clearTimeout(this.loadPipelineDebounce);
      this.loadPipelineDebounce = setTimeout(() => {
        this.loadPipelineDebounce = null;
        this.loadPipeline();
      }, this.isEmbedded ? 300 : 0);
    },
    async loadPipeline() {
      if (this.getPipelineLoading) return;
      try {
        const selectedOps = Array.isArray(this.filterOperation)
          ? this.filterOperation.map((o) => (o && o.value != null ? o.value : o)).filter((v) => v != null)
          : null;
        const operationParam = selectedOps && selectedOps.length > 0 ? selectedOps.join(",") : null;
        const clientId = this.filterClient && this.filterClient.id ? this.filterClient.id : null;
        const dossierId = this.filterDossier && this.filterDossier.id ? this.filterDossier.id : null;
        const isSuperAdmin = this.getOnlineUser?.role === "user.super-admin";
        let entrepriseId = null;
        if (isSuperAdmin) {
          const selected = Array.isArray(this.filterEntreprise) ? this.filterEntreprise : [];
          const ids = selected.map((e) => e && e.id).filter((id) => id != null);
          entrepriseId = ids.length > 0 ? ids.join(",") : null;
        } else {
          entrepriseId = this.getOnlineUser?.entreprise?.id ?? this.getOnlineUser?.entreprise ?? null;
        }
        const data = await this.getPipeline({
          entreprise_id: entrepriseId,
          operation: operationParam,
          client_id: clientId,
          dossier_id: dossierId,
          processus_id: this.computedProcessusId,
        });
        let cols = [];
        if (data) {
          if (Array.isArray(data.columns)) cols = data.columns;
          else if (Array.isArray(data.data)) cols = data.data;
          else if (Array.isArray(data)) cols = data;
        }
        cols = this.normalizeColumns(cols);
        this.columns = cols;
        this.nextCardId = (data && data.nextCardId) || 1;
        this.nextColumnId = (data && data.nextColumnId) || 10;
        let maxSs = (data && data.nextSousSectionId) || 1;
        cols.forEach((c) => {
          (c.sousSections || []).forEach((ss) => {
            const m = parseInt(String(ss.id).replace(/\D/g, ""), 10);
            if (!isNaN(m) && m >= maxSs) maxSs = m + 1;
          });
        });
        this.nextSousSectionId = maxSs;
      } catch {
        this.columns = [];
      }
    },
    loadFromStorage() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed = JSON.parse(stored);
          let cols = parsed.columns || [];
          cols = this.normalizeColumns(cols);
          this.columns = cols;
          this.nextCardId = parsed.nextCardId || 1;
          this.nextColumnId = parsed.nextColumnId || 10;
          let maxSs = parsed.nextSousSectionId || 1;
          cols.forEach((c) => {
            (c.sousSections || []).forEach((ss) => {
              const m = parseInt(String(ss.id).replace(/\D/g, ""), 10);
              if (!isNaN(m) && m >= maxSs) maxSs = m + 1;
            });
          });
          this.nextSousSectionId = maxSs;
        } else {
          this.columns = [];
        }
      } catch {
        this.columns = [];
      }
    },
    normalizeColumns(cols) {
      return cols.map((c) => {
        const raw = c.sous_pipelines || c.sousSections || [];
        const sousSections = raw.map((sp) => {
          const cardsRaw = sp.tasks || sp.cards || [];
          const cards = cardsRaw.map((t) => {
            const dossier = t.dossier;
            const dossierName = dossier?.name || t.name || "";
            const dossierRef = dossier?.numero_dossier || "";
            const clientName = dossier?.client ? this.clientLabel(dossier.client) : "";
            return {
              id: t.id,
              name: dossierName || dossierRef || t.name || "",
              dossier_id: t.dossier_id,
              client_id: dossier?.client_id ?? t.client_id,
              dossier_name: dossierName,
              dossier_reference: dossierRef,
              client_name: clientName,
            };
          });
          return {
            id: sp.id,
            name: sp.name || "",
            pipeline_id: sp.pipeline_id,
            operations: sp.operations || [],
            cards,
          };
        });
        return {
          ...c,
          sousSections,
          cards: undefined,
        };
      });
    },
    savePipelineData(payload, onCreated) {
      this.savePipeline(payload)
        .then((result) => {
          if (onCreated && result) onCreated(result);
          return this.loadPipeline();
        })
        .catch(() => {
          this.saveToStorage();
        });
    },
    updatePipelineData(payload) {
      this.updatePipeline(payload)
        .then(() => this.loadPipeline())
        .catch(() => {
          this.saveToStorage();
        });
    },
    saveToStorage() {
      try {
        const data = {
          columns: this.columns,
          nextCardId: this.nextCardId,
          nextColumnId: this.nextColumnId,
          nextSousSectionId: this.nextSousSectionId,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        console.warn("Pipeline save failed", e);
      }
    },
    getSousSections(col) {
      const list = col.sousSections || [];
      const selectedOps = Array.isArray(this.filterOperation)
        ? this.filterOperation.map((o) => (o && o.value != null ? o.value : o)).filter((v) => v != null)
        : [];
      if (selectedOps.length === 0) return list;
      return list.filter((ss) => {
        const ops = ss.operations || (ss.operation != null ? [ss.operation] : []);
        return ops.length === 0 || selectedOps.some((sel) => ops.includes(sel));
      });
    },
    getSousSectionCards(ss) {
      let cards = ss.cards || [];
      const selectedOps = Array.isArray(this.filterOperation)
        ? this.filterOperation.map((o) => (o && o.value != null ? o.value : o)).filter((v) => v != null)
        : [];
      if (selectedOps.length > 0) {
        cards = cards.filter((c) => {
          const ops = c.operations || (c.operation != null ? [c.operation] : []);
          return ops.length === 0 || selectedOps.some((sel) => ops.includes(sel));
        });
      }
      if (this.filterDossier && this.filterDossier.id) {
        cards = cards.filter((c) => c.dossier_id == this.filterDossier.id);
      }
      if (this.filterClient && this.filterClient.id) {
        cards = cards.filter((c) => c.client_id == this.filterClient.id);
      }
      return cards;
    },
    getColumnCards(col) {
      const sections = col.sousSections || [];
      return sections.reduce((acc, ss) => acc.concat(this.getSousSectionCards(ss)), []);
    },
    getColumnById(id) {
      return this.columns.find((c) => c.id === id);
    },
    openAddSectionModal() {
      this.resetSectionModal();
      this.editingSectionColumn = null;
      this.$refs.addSectionModal.show();
    },
    openEditSectionModal(col) {
      this.editingSectionColumn = col;
      this.newSection = {
        name: col.name,
        color: col.color || "#6c757d",
        icon: col.icon || "check",
        operation: col.operation,
      };
      this.$refs.addSectionModal.show();
    },
    resetSectionModal() {
      this.editingSectionColumn = null;
      this.newSection = { name: "", color: "#6c757d", icon: "check", operation: null };
    },
    addSection() {
      if (!this.newSection.name.trim()) return;
      const col = {
        id: "col-" + this.nextColumnId++,
        name: this.newSection.name.trim().toUpperCase(),
        color: this.newSection.color || "#6c757d",
        icon: this.newSection.icon || "check",
        operation: this.newSection.operation,
        sousSections: [],
      };
      this.columns.push(col);
      const newOrder = this.columns.length - 1;
      const payload = {
        order: newOrder,
        name: col.name,
        color: col.color,
        icon: col.icon,
        processus_id: this.computedProcessusId,
      };
      this.savePipelineData(payload, (created) => {
        const id = created?.id ?? created?.data?.id;
        if (id != null && typeof id === "number") {
          const c = this.columns.find((x) => x.id === col.id);
          if (c) c.id = id;
        }
      });
      this.$refs.addSectionModal.hide();
    },
    updateSection() {
      if (!this.newSection.name.trim() || !this.editingSectionColumn) return;
      const col = this.getColumnById(this.editingSectionColumn.id);
      if (!col) return;
      col.name = this.newSection.name.trim().toUpperCase();
      col.color = this.newSection.color || "#6c757d";
      col.icon = this.newSection.icon || "check";
      col.operation = this.newSection.operation;
      const order = this.columns.findIndex((c) => c.id === col.id);
      const payload = {
        id: col.id,
        order,
        name: col.name,
        color: col.color,
        icon: col.icon,
        processus_id: this.computedProcessusId,
      };
      this.updatePipelineData(payload);
      this.$refs.addSectionModal.hide();
    },
    openAddSousSectionModal(col) {
      this.addSousSectionFromHeader = false;
      this.addSousSectionTargetColumn = col;
      this.addSousSectionTargetColumnId = col.id;
      this.newSousSection = { name: "", operations: [] };
      this.$refs.addSousSectionModal.show();
    },
    openAddSousSectionFromHeader() {
      this.addSousSectionFromHeader = true;
      this.addSousSectionTargetColumn = null;
      this.addSousSectionTargetColumnId = this.columns.length ? this.columns[0].id : null;
      this.newSousSection = { name: "", operations: [] };
      this.$refs.addSousSectionModal.show();
    },
    resetSousSectionModal() {
      this.addSousSectionTargetColumn = null;
      this.addSousSectionFromHeader = false;
      this.addSousSectionTargetColumnId = null;
      this.newSousSection = { name: "", operations: [] };
    },
    async addSousSection() {
      if (!this.newSousSection.name.trim()) return;
      let colId = this.addSousSectionFromHeader ? this.addSousSectionTargetColumnId : (this.addSousSectionTargetColumn && this.addSousSectionTargetColumn.id);
      if (!colId) return;
      if (typeof colId === "string" && !/^\d+$/.test(colId)) {
        this.$bvToast?.toast(this.$t("PIPELINE_SAVE_PENDING") || "Veuillez attendre que la section soit enregistrée.", { variant: "warning" });
        return;
      }
      const pipelineId = typeof colId === "number" ? colId : parseInt(colId, 10);
      if (isNaN(pipelineId)) return;
      const name = this.newSousSection.name.trim();
      const payload = { pipeline_id: pipelineId, name };
      try {
        await this.saveSousPipeline(payload);
        await this.loadPipeline();
        this.$refs.addSousSectionModal.hide();
      } catch (e) {
        const col = this.getColumnById(colId);
        if (col) {
          col.sousSections = col.sousSections || [];
          col.sousSections.push({
            id: "ss-" + this.nextSousSectionId++,
            name,
            operations: [],
            cards: [],
          });
        }
        this.$refs.addSousSectionModal.hide();
      }
    },
    async removeSousSection(col, ss) {
      const c = this.getColumnById(col.id);
      if (!c || !c.sousSections) return;
      if (c.sousSections.length <= 1) {
        if (!confirm( "Dernière sous-section. La supprimer ?")) return;
      } else {
        if (!confirm( "Supprimer cette sous-section ?")) return;
      }
      try {
        await this.deleteSousPipeline(ss.id);
        c.sousSections = c.sousSections.filter((x) => x.id !== ss.id);
        this.$bvToast && this.$bvToast.toast("Sous-section supprimée.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 5000 });
      }
    },
    async openAddTaskModal(col, ss) {
      this.addTaskTargetColumn = col;
      this.addTaskTargetSousSection = ss;
      this.newTask = { dossier: null };
      const operation = col?.operation;
      const entrepriseId = this.getOnlineUser?.entreprise?.id ?? this.getOnlineUser?.entreprise ?? null;
      try {
        await this.dossiersByOperation({
          operation: operation ?? undefined,
          entreprise_id: entrepriseId,
          noasigned: this.noasigned,
          page: 1,
          per_page: 500,
        });
      } catch {
        // Fallback: use full list if API fails
      }
      this.$refs.addTaskModal.show();
    },
    resetTaskModal() {
      this.addTaskTargetColumn = null;
      this.addTaskTargetSousSection = null;
      this.newTask = { dossier: null };
    },
    async addTask() {
      const d = this.newTask.dossier;
      if (!d || !d.id || !this.addTaskTargetColumn || !this.addTaskTargetSousSection) return;
      const ss = this.addTaskTargetSousSection;
      const cardName = d.name || d.numero_dossier || "Dossier #" + d.id;
      const payload = {
        sous_pipeline_id: ss.id,
        dossier_id: d.id,
      };
      try {
        await this.saveTask(payload);
        await this.loadPipeline();
        this.$refs.addTaskModal.hide();
      } catch {
        const col = this.getColumnById(this.addTaskTargetColumn.id);
        const targetSs = (col?.sousSections || []).find((s) => s.id === ss.id);
        if (targetSs) {
          targetSs.cards = targetSs.cards || [];
          targetSs.cards.push({
            id: "card-" + this.nextCardId++,
            name: cardName,
            dossier_id: d.id,
            client_id: d.client_id || null,
            dossier_name: cardName,
            dossier_reference: d.numero_dossier || "",
            client_name: d.client ? this.clientLabel(d.client) : "",
          });
        }
        this.$refs.addTaskModal.hide();
      }
    },
    async removeCard(card, col, ss) {
      const s = (col?.sousSections || []).find((x) => x.id === ss.id);
      try {
        await this.deleteTask(card.id);
        await this.loadPipeline();
      } catch {
        if (s && s.cards) {
          s.cards = s.cards.filter((x) => x.id !== card.id);
        }
      }
    },
    async removeSection(col) {
      if (!confirm("Supprimer cette section ?")) return;
      try {
        await this.deletePipeline(col.id);
        this.columns = this.columns.filter((c) => c.id !== col.id);
        this.$bvToast && this.$bvToast.toast( "Section supprimée.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 5000 });
      }
    },
    async moveCardToColumn(card, fromCol, fromSs, toCol, toSs) {
      const from = this.getColumnById(fromCol.id);
      const to = this.getColumnById(toCol.id);
      if (!from || !to) return;
      const targetSs = toSs || (to.sousSections && to.sousSections[0]);
      if (!targetSs) return;
      try {
        await this.updateTask({ id: card.id, sous_pipeline_id: targetSs.id });
        await this.loadPipeline();
      } catch {
        const fromSection = (from.sousSections || []).find((s) => s.id === (fromSs && fromSs.id));
        if (fromSection) {
          fromSection.cards = (fromSection.cards || []).filter((c) => c.id !== card.id);
        }
        const toSection = (to.sousSections || []).find((s) => s.id === targetSs.id);
        if (toSection) {
          toSection.cards = toSection.cards || [];
          toSection.cards.push(card);
        }
      }
    },
    onSousSectionDragOver(ev, col, ss) {
      this.dragOverSousSectionId = ss.id;
    },
    onSousSectionDragLeave() {
      this.dragOverSousSectionId = null;
    },
    onSousSectionDrop(ev, toCol, toSs) {
      ev.stopPropagation();
      this.dragOverSousSectionId = null;
      const data = ev.dataTransfer.getData("text/plain");
      try {
        const parsed = JSON.parse(data);
        if (parsed.type === "card" && this.draggingCard && this.draggingCardFromColumn) {
          this.moveCardToColumn(this.draggingCard, this.draggingCardFromColumn, this.draggingCardFromSousSection, toCol, toSs);
        }
      } catch (_e) {
        // Ignore
      }
    },
    onCardDragStart(ev, card, fromCol, fromSs) {
      this.draggingCard = card;
      this.draggingCardFromColumn = fromCol;
      this.draggingCardFromSousSection = fromSs;
      ev.dataTransfer.effectAllowed = "move";
      ev.dataTransfer.setData("text/plain", JSON.stringify({ type: "card", cardId: card.id }));
    },
    onCardDragEnd() {
      this.draggingCard = null;
      this.draggingCardFromColumn = null;
      this.draggingCardFromSousSection = null;
      this.dragOverColumnId = null;
      this.dragOverSousSectionId = null;
    },
    onColumnDragOver(ev, col) {
      this.dragOverColumnId = col.id;
    },
    onColumnDragLeave() {
      this.dragOverColumnId = null;
    },
    onColumnDrop(ev, toCol) {
      ev.stopPropagation();
      this.dragOverColumnId = null;
      const data = ev.dataTransfer.getData("text/plain");
      try {
        const parsed = JSON.parse(data);
        if (parsed.type === "column" && this.draggingColumn) {
          const fromIdx = this.columns.findIndex((c) => c.id === this.draggingColumn.id);
          const toIdx = this.columns.findIndex((c) => c.id === toCol.id);
          if (fromIdx >= 0 && toIdx >= 0 && fromIdx !== toIdx) {
            const arr = [...this.columns];
            const [removed] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, removed);
            this.columns = arr;
          }
        } else if (parsed.type === "card" && this.draggingCard && this.draggingCardFromColumn) {
          this.moveCardToColumn(this.draggingCard, this.draggingCardFromColumn, this.draggingCardFromSousSection, toCol, null);
        }
      } catch (_e) {
        // Ignore parse errors from drag data
      }
    },
    onColumnDragStart(ev, col, colIndex) {
      this.draggingColumn = col;
      this.draggingColumnIndex = colIndex;
      ev.dataTransfer.effectAllowed = "move";
      ev.dataTransfer.setData("text/plain", JSON.stringify({ type: "column", columnId: col.id }));
    },
    onColumnDragEnd() {
      this.draggingColumn = null;
      this.draggingColumnIndex = null;
      this.dragOverColumnId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.pipeline-page ::v-deep .page-header {
  width: 100%;

  h1 {
    width: 97.7% !important;
  }
}

.pipeline-content {
  margin: 10px 15px;
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pipeline-page.pipeline-embedded {
  margin: 0;
  padding: 0;
}

.pipeline-content.pipeline-content-embedded {
  margin: 0;
  padding: 0;
  box-shadow: none;
  background: transparent;
}

.pipeline-content-embedded .pipeline-board {
  min-height: 65vh;
  padding: 12px 16px;
  background: transparent;
}

.pipeline-content-embedded .pipeline-column {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.pipeline-content-embedded .pipeline-column-header {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.pipeline-content-embedded .pipeline-card {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, transform 0.2s;
}

.pipeline-content-embedded .pipeline-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.pipeline-content-embedded .pipeline-add-section-column {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.pipeline-content-embedded .pipeline-add-section-column:hover {
  background: #f1f5f9;
  border-color: #465081;
  box-shadow: 0 2px 8px rgba(70, 80, 129, 0.15);
}

.pipeline-card-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.pipeline-filter-select {
  max-width: 160px;
  min-width: 140px;
}

.pipeline-filter-multiselect {
  max-width: 180px;
  min-width: 140px;
}

.pipeline-board {
  display: flex;
  gap: 16px;
  padding: 16px;
  min-height: 70vh;
  align-items: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  flex: 1;
}

.pipeline-add-section-column {
  flex: 0 0 280px;
  min-width: 280px;
  min-height: 120px;
  background: #f1f5f9;
  border: 2px dashed #94a3b8;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: #64748b;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background: #e2e8f0;
    border-color: #3b82f6;
    color: #3b82f6;
  }

  .add-section-icon {
    font-size: 24px;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
}

.pipeline-column {
  flex: 0 0 280px;
  min-width: 280px;
  background: #f1f5f9;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 180px);
  transition: box-shadow 0.2s;

  &.column-dragover {
    box-shadow: 0 0 0 2px #3b82f6;
  }
}

.pipeline-column-header {
  padding: 12px 16px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  .column-icon {
    font-size: 16px;
    opacity: 0.9;
  }

  .column-name {
    flex: 1;
  }

  .column-count {
    background: rgba(255, 255, 255, 0.3);
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
  }

  .column-edit-btn {
    color: rgba(255, 255, 255, 0.8);
    padding: 4px;

    &:hover {
      color: white;
    }
  }

  .column-remove-btn {
    color: rgba(255, 255, 255, 0.8);
    padding: 4px;

    &:hover {
      color: white;
    }
  }
}

.pipeline-column-content {
  padding: 12px;
  overflow-y: auto;
  flex: 1;
}

.pipeline-card {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  cursor: grab;
  position: relative;

  &:active {
    cursor: grabbing;
  }

  .card-name {
    font-weight: 500;
    font-size: 14px;
    color: #334155;
  }

  .card-reference {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;
  }

  .card-client {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
  }

  .card-meta {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;

    .card-eye {
      margin-right: 4px;
    }
  }

  .card-remove-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px;
    color: #94a3b8;

    &:hover {
      color: #ef4444;
    }
  }
}

.column-empty {
  text-align: center;
  padding: 16px;
  color: #94a3b8;
  font-size: 12px;
}

.pipeline-sous-section {
  background: #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 12px;

  &.sous-section-dragover {
    box-shadow: 0 0 0 2px #475569;
  }
}

.pipeline-content-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  width: 100%;
  position: relative;
  
  .loading-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    .spinner-border {
      color: #475569;
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }
    
    p {
      color: #64748b;
      font-size: 16px;
      margin: 0;
      font-weight: 500;
    }
  }
}

.sous-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.sous-section-remove {
  padding: 2px 6px;
  color: #94a3b8;

  &:hover {
    color: #ef4444;
  }
}

.add-sous-section-btn {
  width: 100%;
  margin-top: 4px;
  border-style: dashed;
}

.add-task-btn {
  width: 100%;
  margin-top: 8px;
  border-style: dashed;
}

.color-picker {
  width: 40px;
  height: 36px;
  padding: 2px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
}
</style>
